import { Platform } from 'react-native';
import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const CIRCLE_STROKE_COLOR = Platform.select({
  web: theme.colors.OPACITY.KALE.DARKER,
  default: theme.colors.OPACITY.KALE.DARK,
});
export const CIRCLE_STROKE_WIDTH = 2;
export const CIRCLE_FILL_COLOR = Platform.select({
  web: theme.colors.OPACITY.KALE.LIGHTER,
  default: theme.colors.OPACITY.KALE.LIGHTEST,
});
